import { render, staticRenderFns } from "./ProbabilityLogo.vue?vue&type=template&id=180b6fcc&"
import script from "./ProbabilityLogo.vue?vue&type=script&lang=js&"
export * from "./ProbabilityLogo.vue?vue&type=script&lang=js&"
import style0 from "./ProbabilityLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports